import { FC, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Drawer, List, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import { APP_BAR_HEIGHT } from '@constants';
import { CoreBox } from '@youscience/core';

import AccessWrapper from '@components/AccessWrapper';
import { USER_ROLES } from '@constants';

import { NAVIGATION_ITEMS } from './constants';
import { SideNavProps } from './types';
import { StyledListItemButton, sxStyles } from './SideNav.styles';

export const SideNav: FC<SideNavProps> = () => {
  const location = useLocation();

  return (
    <Drawer variant="permanent" sx={sxStyles.drawer}>
      <Toolbar sx={{ height: APP_BAR_HEIGHT }} />
      <CoreBox sx={{ overflow: 'auto' }}>
        <List sx={{ paddingTop: '0px' }}>
          {NAVIGATION_ITEMS.map((item) => (
            <Fragment key={item.key}>
              <AccessWrapper allowedRoles={item?.allowedRoles ?? [USER_ROLES.ADMIN]} restrictOrg={item.restrictOrg}>
                <StyledListItemButton component={Link} item={item} key={item.key} location={location} to={item.path}>
                  <ListItemIcon sx={sxStyles.navListItemIcon}>{item.icon}</ListItemIcon>
                  <ListItemText>{item.title}</ListItemText>
                </StyledListItemButton>
              </AccessWrapper>
            </Fragment>
          ))}
        </List>
      </CoreBox>
    </Drawer>
  );
};
